<template>
  <div class="animated fadeIn">

    <ChangeControlUnitComponent v-if="!$store.state.currentUnit.id" />
    <ChangeControlHeaderComponent v-if="$store.state.currentUnit.id" />

   

    
    <b-row>
      <b-col md="12">
        <b-card header="DENOMINAÇÕES" v-if="$store.state.currentUnit.id">

        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">{{ data_change_outgoing && data_change_outgoing.length > 1 ? data_change_outgoing.length + " Retiradas" : (data_change_outgoing.length == 1 ? "1 Retirada" : "Nenhuma retirada") }}</h4>
            <div class="small text-muted">&nbsp;</div>
            <div class="small text-muted">&nbsp;</div>
          </b-col>
          
          <b-col sm="7" class="d-none d-md-block">
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                  <b-button type="button" @click="getDenominations()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
                  <span style="width:10px"></span>
                  <b-button type="button" @click="$bvModal.show('help-denomination')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
              </b-button-toolbar>
          </b-col>

        </b-row>

        <b-row>
              
            <b-col sm="12" class="">
              <b-button-toolbar class="float-left" aria-label="Toolbar with buttons group">
                <b-button type="button" :to="{ path: '/changecontrol/movementin' }" variant="success" class="float-right">Entrada de Denominações</b-button>
                <span style="width: 10px"></span>
                <b-button type="button" :to="{ path: '/changecontrol/movementout' }" variant="success" class="float-right">Saída de Denominações</b-button>
                <!--
                <span style="width: 10px"></span>
                <b-button type="button" :to="{ path: '/changecontrol/denominationadjustment' }" variant="danger" class="float-right">Ajuste de Denominações</b-button>
                -->
            </b-button-toolbar>
            
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-button type="button" :to="{ path: '/changecontrol/denominationexchange' }" variant="primary" class="float-right">Troca de Denominação</b-button>
                <span style="width: 10px"></span>
                <b-button type="button" :to="{ path: '/changecontrol/changeoutgoing' }" variant="danger" class="float-right">Nova Retirada</b-button>
                
                
            </b-button-toolbar>
            
            </b-col>
        </b-row>

      
        <b-row>
          <b-col sm="12" md="6" lg="4" xl="3" v-for="item in data_denomination" :key="item.id">
            <Callout :variant="item.variant">
              <small class="text-muted">R$ {{ numberFormat(item.value) }}</small><br>
              <strong class="h4">x {{ item.totalQuantity }}</strong><br>
              <small class="text-muted"><img :src="item.image" width="80" :style="{ width: item.imageWidth +'px' }"></small>
              <div class="chart-wrapper" :style="{ top: '-10px'}">
                <callout-chart-example chartId="callout-chart-01" :data="item.chart" :variant="[item.variant]" width="80" height="30" :labels="['Qua', 'Qui', 'Sex', 'Sab', 'Dom','Seg', 'Ter']" />
                <br>
                <small>R$</small> <strong class="h4"> {{ numberFormat( item.value * item.totalQuantity ) }}</strong>
              </div>                    
            </Callout>
          </b-col>
        </b-row>

        <div slot="footer">
          <ChangeControlFooterComponent :controlitem="data_change_denomination_summary" :controltype="1" />

          
        </div>
         
        </b-card>
      </b-col>
    </b-row>
   
    <b-card header="RETIRADAS" v-if="$store.state.currentUnit.id && data_change_outgoing && data_change_outgoing.length > 0">

      <b-row>
          <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">&nbsp;</h4>
          <div class="small text-muted">&nbsp;</div>
          <div class="small text-muted">&nbsp;</div>
          </b-col>
          <b-col sm="7" class="">
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-button type="button" :to="{ path: '/changecontrol/changeoutgoing' }" variant="danger" class="float-right">Nova Retirada</b-button>
              <span style="width:10px"></span>
              <b-button type="button" @click="getWaitingReturn()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
              <span style="width:10px"></span>
              <b-button type="button" @click="$bvModal.show('help-movement-withdraw')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
          </b-button-toolbar>
          
          </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" lg="3" v-for="item in data_change_outgoing" :key="item.id">
        <ChangeControlItemComponent :controlitem="item" :controltype="1" />
        </b-col>
      </b-row>
    
      <div slot="footer">
        <ChangeControlFooterComponent :controlitem="data_change_outgoing_summary" :controltype="1" />

      </div>

    </b-card>

    <b-card header="DEVOLUÇÕES PENDENTES DE AUTORIZAÇÃO" v-if='data_change_return && data_change_return.length > 0'>

      <b-row>
          <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">&nbsp;</h4>
          <div class="small text-muted">&nbsp;</div>
          <div class="small text-muted">&nbsp;</div>
          </b-col>
          <b-col sm="7" class="">
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-button type="button" @click="getWaitingApproval()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
              <span style="width:10px"></span>

              <b-button type="button" @click="$bvModal.show('help-movement-approval')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
          </b-button-toolbar>
          
          </b-col>
      </b-row>


      <b-row>
        <b-col sm="6" lg="3" v-for="item in data_change_return" :key="item.id">
        <ChangeControlItemComponent :controlitem="item" :controltype="2" />
        </b-col>
      </b-row>

      <div slot="footer">
        <ChangeControlFooterComponent :controlitem="data_change_return_summary" :controltype="1" />
      
      </div>

    </b-card>



    <div>
      <b-modal id="help-denomination" title="Ajuda" ok-only size="lg"
      ok-title="Fechar">
          <h3>Controle de Troco - Caixa Principal</h3>
          <p class="my-4">
              Permite controlar a quantidade de denominações disponibilizadas para o Controle de Troco para uma Praça.<br>
              Nessa tela também é possível visualizar e gerenciar as <i>Últimas Retiradas</i> realizadas e as <i>Devoluções Pendentes de Autorização</i>
          </p>
          
          <h4>Denominações</h4>


          <p class="my-4">
          É exibido uma lista com todas as denominações (cédulas e moedas) disponíveis para a Praça especifida.<br>
          As ações possíveis são:
          <ol>
            <li><i>Entrada de Denominação</i> - Ajuste ou quantidade inicial de cédulas e moedas do Controle de Troco da praça</li>
            <li><i>Saída de Denominação</i> - Ajuste ou retirada de cédulas e moedas do Controle de Troco da praça</li>
            <li><i>Nova Retirada</i> - Retirada de denominação para outro usuário</li>
            <!--
            <li><i>Troca de Denominação</i> - Troca de cédulas ou moedas</li>
            -->
          </ol>
          </p>
          
      </b-modal>
    </div>

    <div>
      <b-modal id="help-movement-withdraw" title="Ajuda" ok-only size="lg"
      ok-title="Fechar">
          <h3>Controle de Troco</h3>
          <p class="my-4">
              Permite controlar a quantidade de denominações disponibilizadas para o Controle de Troco para uma Praça.<br>
              Nessa tela também é possível visualizar e gerenciar as <i>Últimas Retiradas</i> realizadas e as <i>Devoluções Pendentes de Autorização</i>
          </p>
          
          <h4>Última Retiradas</h4>
          <p class="my-4">
          <ol>
              <li>Uma lista com as útlimas retiradas feitas no controle de troco da praça.</li>
              <li>Para criar uma devolução clique no menu de ações da Retirada correspondente e selecione <i>Entrada / Devolução</i>.</li>
              <li>É possível criar uma nova retirada para um usuário clicando no botão <i>Nova Retirada</i>.</li>   
          </ol>
          </p>

      </b-modal>
    </div>


  </div>
</template>

<script>
import axios from "axios";
import CalloutChartExample from './ChangeControlChar'
import { Callout } from '@coreui/vue'
import ChangeControlItemComponent from '../../components/ChangeControlItemComponent'
import ChangeControlFooterComponent from '../../components/ChangeControlFooterComponent'
import ChangeControlUnitComponent from '../../components/ChangeControlUnitComponent'
import ChangeControlHeaderComponent from '../../components/ChangeControlHeaderComponent'

export default {
  name: 'dashboard',
  components: {
    Callout,
    CalloutChartExample,
    ChangeControlItemComponent,
    ChangeControlFooterComponent,
    ChangeControlUnitComponent,
    ChangeControlHeaderComponent,
  },
  data: function () {
    return {
      data_change_outgoing_summary: { total: 0, coins: 0, notes: 0},
      data_change_return_summary: { total: 0, coins: 0, notes: 0},
      data_change_denomination_summary: { total: 0, coins: 0, notes: 0},

      data_change_outgoing: [
        /*
        { id: 1, user: 123456, username: 'Alexandre Kenji Takamura', startdate: '2022-06-16 16:27:12', total: 200, total_coin: 35, class: 'bg-primary' },
        { id: 2, user: 234567, username: 'José Emílio do Prado', startdate: '2022-06-16 13:41:12', total: 250, total_coin: 20, class: 'bg-success' },
        { id: 3, user: 345678, username: 'Maria Fernanda Cândido', startdate: '2022-06-16 12:54:20', total: 300, total_coin: 16.20, class: 'bg-info' },
        { id: 4, user: 456789, username: 'José de Arimateia', startdate: '2022-06-16 11:22:32', total: 350, total_coin: 30.25, class: 'bg-warning' },
        { id: 5, user: 567890, username: 'Thomas Gibson', startdate: '2022-06-16 09:56:32', total: 470, total_coin: 80.80, class: 'bg-danger' },
        { id: 6, user: 567890, username: 'Thomas Gibson', startdate: '2022-06-16 09:56:32', total: 470, total_coin: 80.80, class: 'bg-danger' },
        */
      ],
      data_change_return: [
        /*
        { id: 1, user: 678901, username: 'Hommer Simpson', startdate: '2022-06-16 16:27:12', total: 100, total_coin: 20.21, class: 'bg-primary' },
        { id: 2, user: 789012, username: 'Maxwell Smart', startdate: '2022-06-16 13:41:12', total: 80, total_coin: 12, class: 'bg-primary' },
        { id: 3, user: 890123, username: 'Zezé Polessa', startdate: '2022-06-16 12:54:20', total: 200, total_coin: 32.80, class: 'bg-primary' },
        { id: 4, user: 901234, username: 'Tim Maia', startdate: '2022-06-16 11:22:32', total: 150, total_coin: 67.90, class: 'bg-primary' },
        { id: 5, user: 111111, username: 'Johnas John', startdate: '2022-06-16 09:56:32', total: 980, total_coin: 80.15, class: 'bg-primary' },
        { id: 6, user: 222222, username: 'Johnas John', startdate: '2022-06-16 09:56:32', total: 980, total_coin: 80.15, class: 'bg-teal' },
        */
      ],

      data_denomination: [
        /*
        { id: 0, value: 0.01, totalQuantity: 0, color: 'bg-indigo', image: 'img/currency/real_001.png', imageWidth: 80, type: 1, variant: 'warning', chart: [0, 0, 0, 0, 0, 0, 0] },
        { id: 1, value: 0.05, totalQuantity: 200, color: 'bg-indigo', image: 'img/currency/real_005.png', imageWidth: 80, type: 1, variant: 'warning', chart: [70, 23, 56, 22, 97, 23, 14]  },
        { id: 2, value: 0.10, totalQuantity: 250, color: 'bg-indigo', image: 'img/currency/real_010.png', imageWidth: 80, type: 1, variant: 'warning', chart: [80, 23, 56, 60, 97, 23, 6]  },
        { id: 3, value: 0.25, totalQuantity: 100, color: 'bg-indigo', image: 'img/currency/real_025.png', imageWidth: 80, type: 1, variant: 'warning', chart: [60, 23, 56, 10, 97, 23, 34]  },
        { id: 4, value: 0.50, totalQuantity: 100, color: 'bg-indigo', image: 'img/currency/real_050.png', imageWidth: 80, type: 1, variant: 'warning', chart: [90, 23, 56, 2, 97, 23, 64]  },
        { id: 5, value: 1, totalQuantity: 200, color: 'bg-indigo', image: 'img/currency/real_1.png', imageWidth: 80, type: 1, variant: 'warning', chart: [10, 23, 58, 22, 7, 23, 64]  },
        { id: 7, value: 2, totalQuantity: 50, color: 'bg-indigo', image: 'img/currency/real_2.png', imageWidth: 120, type: 2, variant: 'success', chart: [0, 23, 56, 22, 1, 23, 74]  },
        { id: 8, value: 5, totalQuantity: 50, color: 'bg-indigo', image: 'img/currency/real_5.png', imageWidth: 120, type: 2, variant: 'success', chart: [50, 23, 36, 22, 97, 23, 64]  },
        { id: 9, value: 10, totalQuantity: 100, color: 'bg-indigo', image: 'img/currency/real_10.png', imageWidth: 120, type: 2, variant: 'success', chart: [30, 23, 56, 22, 97, 23, 64]  },
        { id: 10, value: 20, totalQuantity: 80, color: 'bg-indigo', image: 'img/currency/real_20.png', imageWidth: 120, type: 2, variant: 'success', chart: [80, 83, 56, 33, 97, 23, 44]  },
        { id: 11, value: 50, totalQuantity: 10, color: 'bg-indigo', image: 'img/currency/real_50.png', imageWidth: 120, type: 2, variant: 'success', chart: [20, 23, 7, 22, 97, 100, 64] },
        { id: 12, value: 100, totalQuantity: 0, color: 'bg-indigo', image: 'img/currency/real_100.png', imageWidth: 120, type: 2, variant: 'success', chart: [0, 1, 0, 0, 0, 0, 0]  },
        */
      ]
    }
  },
    computed: {
        currentUserId() {
            return this.$store.state.currentUser.id;
        },
        currentUnitId() {
            return this.$store.state.currentUnit.id;
        }
    },
    watch: {
        currentUnitId(newId, oldId) {
            //console.log("Unit changed: " + oldId + " - " + newId)            
            this.getDenominations()
            this.getWaitingReturn()
            this.getWaitingApproval()
            this.changeTotal()
        },
        currentUserId(newId, oldId) {
            //console.log("Operator changed: " + oldId + " - " + newId)             
        },
    },
  methods: {
     async getDenominations() {
            try {
                if(this.$store.state.currentUser.code && this.$store.state.currentUnit.originId) {
                    const denominationsResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/denominations?withChart=true&originId=" + this.$store.state.currentUnit.originId + "&operatorCode=" + this.$store.state.currentUser.code
                    );
                    this.data_denomination = denominationsResponse.data.controlDenominations
                    //console.log(waitingReturnResponse.data)

                    this.changeTotal()
                }
                else {
                     this.data_denomination = []
                }
            } catch (e) {
                console.log(e)                 
            }  
        },

    async getWaitingApproval() {
            try {
              if(this.$store.state.currentUnit.originId) {                
                const waitingApprovalResponse = await axios.get(
                    this.$store.state.ws_url + "/changecontrol/movement?typeCode=3&status=3&originId=" + this.$store.state.currentUnit.originId
                );
                this.data_change_return = waitingApprovalResponse.data
                //console.log(waitingApprovalResponse.data)

                this.changeTotal()

              }
              else {
                this.data_change_return = [];
              }
            } catch (e) {
                console.log(e)                 
            }  
        },

    async getWaitingReturn() {
            try {
              if(this.$store.state.currentUnit.originId) {
                const waitingReturnResponse = await axios.get(
                    this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId
                );
                this.data_change_outgoing = waitingReturnResponse.data
                //console.log(waitingReturnResponse.data)

                 this.changeTotal()

              }
              else {
                this.data_change_outgoing = [];
              }
            } catch (e) {
                console.log(e)                 
            }  
        },
    numberFormat(x) {
            return parseFloat(x).toFixed(2).toString().replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
   
    changeTotalChange(data_change, data_summary) {
      var total = 0
      var total_coin = 0

      //console.log(data_change)

      data_change.forEach(function(item) {
      total_coin += item.totalCoin
        total += item.total
      })

      data_summary.total = total
      data_summary.coins = total_coin
      data_summary.notes = total - total_coin

      //console.log("changeTotalChange: ")
      //console.log(data_summary)

    },

    changeTotalDenomination(data_change, data_summary) {
      var total = 0
      var total_coin = 0

      data_change.forEach(function(item) {
        if(item.type == 1)
          total_coin += item.totalQuantity * item.value
        total += item.totalQuantity * item.value
      })

      data_summary.total = total
      data_summary.coins = total_coin
      data_summary.notes = total - total_coin

    },
  
    changeTotal() {
      this.changeTotalChange(this.data_change_outgoing, this.data_change_outgoing_summary)
      this.changeTotalChange(this.data_change_return, this.data_change_return_summary)
      this.changeTotalDenomination(this.data_denomination, this.data_change_denomination_summary)
    },

        
  },
  mounted: function(){
    this.getDenominations()
    this.getWaitingReturn()
    this.getWaitingApproval()
    this.changeTotal()
  }
}


</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
